import React from 'react';
import { enCurrency, IProductConfig } from 'interfaces/IProductData';
import Br from './Br';
import International from './International';
import { BaseComponent } from 'components/BaseComponent';
import { cartService } from 'services/CartService';
import { IStateBase } from 'components/BaseComponent';
import { enProductType } from 'enums/enProductType';
import QuantityForm from 'components/Cart/Physical/QuantityForm';
import ShippingForm from 'components/Cart/Physical/ShippingForm';
import { currencyService } from '../../services/CurrencyService';

interface IState extends IStateBase {
  config: IProductConfig;
  currency: enCurrency;
}

export default class UserAddressForm extends BaseComponent<IState> {

  constructor(props: any) {
    super(props);
  }

  componentDidMount() {
    this.observeState({ config: null }, cartService.getConfig());
    this.observeState({ currency: null }, currencyService.getCurrency());
  }

  render() {

    if (!this.state) {
      return <div />;
    }

    const { config, currency } = this.state;

    return (
      <div>
        {config.productType === enProductType.PHYSICAL
          && !config.askAddressAfterPayment
          && currency == enCurrency.BRL ?
          <QuantityForm /> : null
        }
        {
          currency == enCurrency.BRL
            ? <Br />
            : <International />
        }

        {config.productType === enProductType.PHYSICAL
          && config.askAddressBeforePayment
          && currency == enCurrency.BRL ?
          <ShippingForm /> : null
        }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/UserAddressForm/index.tsx